import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesService } from 'src/app/services/language.service';
import { BaseService } from 'src/app/services/base.service';
import { Router } from '@angular/router';
import { Func } from '../assistance/func';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})

export class WelcomeComponent implements OnInit {

  name: string;
  partner_name: string = '';
  Mr: string = "";
  Mrs: string = "";

  mailText:string = "";
  localHref: string = "";

  constructor ( private translate: TranslateService,
                public languagesService: LanguagesService,
                private router: Router,
                public func: Func,
                public baseService: BaseService,
              )
  {
    this.translate.get('registration-form.Mr').subscribe((text:string) => {this.Mr = text;});
    this.translate.get('registration-form.Mrs').subscribe((text:string) => {this.Mrs = text;});
    this.localHref = window.location.href;
    let sleshIdx = this.localHref.lastIndexOf("/");
    this.localHref = this.localHref.substring(0, sleshIdx);
  } 

  ngOnInit(): void {
    if (this.baseService.LoggedUser) {
      this.name = this.setName(this.baseService.LoggedUser);
      this.mailText = "mailto:MailParserTest@moia.gov.il?subject=Returning@mi_"+this.baseService.LoggedUser.MEZAHE_ZAFUY_INTERNET+":mz_"+this.baseService.LoggedUser.MISPAR_ZEHUT;
    
      if (this.baseService.LoggedUserPartner)
        this.partner_name = this.setName(this.baseService.LoggedUserPartner);
    }
    else
      this.router.navigateByUrl( '/registration'); //'/login');    
  }

  getMin(user: any) {
    return user.MIN == '1' ? this.Mr : this.Mrs;
  }

  setName(user: any): string {
    return this.getMin(user) + " "
    + user.SHEM_PRATI + " "
    + user.SHEM_MISHPAHA + ",";
  }

  getRegisterForAssistenceLabel (isHeadFamily: boolean = true) {
    return (isHeadFamily && this.baseService.LoggedUser && this.baseService.LoggedUser.MIN == '1') || 
           (!isHeadFamily && this.baseService.LoggedUserPartner && this.baseService.LoggedUserPartner.MIN == '1') ? 
           'registration-form.assistance-link-Mr' : 'registration-form.assistance-link-Mrs';
  }

  goToAssistance (event, isHeadFamily: boolean = true) {
    if (this.baseService.LoggedUser)
    {
      let MEZAHE_ZAFUY_INTERNET = isHeadFamily ? 
        this.baseService.LoggedUser.MEZAHE_ZAFUY_INTERNET : this.baseService.LoggedUserPartner.MEZAHE_ZAFUY_INTERNET;
      let codedMEZAHE_ZAFUY_INTERNET = this.func.encrypt(MEZAHE_ZAFUY_INTERNET);
      
      var winref = window.open('', `assistanceWin${MEZAHE_ZAFUY_INTERNET}`, '', true);
      if(winref.location.href === 'about:blank'){
          winref.location.href = this.localHref + `/assistance/${codedMEZAHE_ZAFUY_INTERNET}`;
      } 
      winref.focus();
    }
    else
      this.router.navigateByUrl('/login');    
    
    event.preventDefault();
  }
}






